<template>
    <div class="poster">
        <van-popup v-model="show" position="right">
            <div class="livingPosterSetting" v-if="bgs.length">
                <i class="close icon-close" @click="closePop"></i>
                <div class="display">
                    <img :src="item.posterurl" alt="" class="poster">
                </div>
                <div class="bottom">
                    <div class="bgs">
                        <div class="box"  alt="" v-for="(obj,index) in bgs" @click="handleSelect(obj)" :key="index">
                            <img v-lazy="obj.sampleatturl" class="img">
                            <i class="icon icon-checked" v-if="obj.innerid==posterinnerid"></i>
                        </div>
                    </div>
                    <div class="btns">
                        <div class="tip">长按保存海报，邀请好友学习</div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
  import {getWXSDKSetting} from 'common/js/wxSDKSetting'
  import {mapGetters, mapActions} from 'vuex'
  import {getAssetPosterList, makeAssetPoster} from 'api/api'
  export default {
    name: 'poster',
    props: ['courseData'],
    data() {
      return {
        show: false,
        bgs: [],
        item: {
          posterurl: ''
        },
        pageurl: '',
        param: {
          cid: this.$route.query.cid ? this.$route.query.cid : '',
          type: 1
        },
        posterinnerid: '', // 选中的背景id
        shareData: {
          title: '',
          desc: '',
          link: '',
          imgUrl: ''
        }
      }
    },
    mounted() {
    },
    methods: {
      openPop() {
        let href = this.$router.resolve({name: 'LivingIndex'}).href
        this.pageurl = window.location.protocol + '//' + window.location.host + href + '?cid=' + this.param.liveid + '&inviteid=' + this.user.innerid
        if (!this.item.posterurl) this._getList()
        this.show = true
      },
      closePop() {
        this.show = false
      },
      handleSelect(obj) {
        this.param.type = obj.code
        this._makeAssetPoster(obj)
      },
      _editKmcShare() {
        let _this = this
        getWXSDKSetting(
          this.shareData,
          function () {
            _this.wxCallBack()
          }
        )
      },
      wxCallBack() {
        console.log('success')
      },
      _makeAssetPoster(obj) {
        this.posterinnerid = obj.innerid
        this.setLoading(true)
        makeAssetPoster({
          data: {
            postertype: obj.posttype, //1系统模板 2自定义模板
            posterinnerid: obj.innerid, //模板id
            kmctype: 7, //媒资类型
            assetinnerid: this.param.cid // 媒资id
          },
          success: data => {
            this.item = data.data
            this.setLoading(false)
            this.shareData = {
              title: this.courseData.subject,
              desc: this.courseData.description,
              link: this.pageurl,
              imgUrl: this.item.posterurl
            }
            this._editKmcShare()
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _getList() {
        let param = {
          kmctype: 7, //媒资类型
          assetinnerid: this.param.cid // 媒资id
        }
        this.setLoading(true)
        getAssetPosterList({
          data: param,
          success: data => {
            this.bgs = data.data.content
            if (this.bgs.length) this.posterinnerid = this.bgs[0].innerid
            this.item.posterurl = data.data.defultposterurl
            this.setLoading(false)
            this.shareData = {
              title: this.item.subject,
              desc: this.item.description,
              link: this.pageurl,
              imgUrl: this.item.logourl
            }
            this._editKmcShare()
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['user'])
    },
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .poster {
        .close{
            position: fixed;
            top: 0.4rem;
            right: 0.5rem;
            width: 0.4rem;
            height: 0.4rem;
        }
        .van-popup--right{
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            transform: translate3d(0,0,0);
            background: transparent;
            .display{
                height: calc(100vh - 1.8rem);
                display: flex;
                justify-content: center;
                align-items: center;
                .poster{
                    width: 5.31rem;
                    height: 9.46rem;
                }
            }
            .bottom {
                position: fixed;
                left: 0;
                right: 0;
                bottom: 0;
                overflow-x: auto;
                background: #fff;
                .bgs {
                    padding: 0.2rem 0.32rem;
                    display: flex;
                    align-items: center;
                    .box{
                        position: relative;
                        width: 0.64rem;
                        height: 0.64rem;
                        border: 0.01rem solid transparent;
                        border-radius: 0.08rem;
                        display: flex;
                        align-items: center;
                        .img {
                            display: block;
                            width: 100%;
                            height: 100%;
                        }
                        .icon{
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            &:before{
                                width: 0.16rem;
                                height: 0.16rem;
                            }
                        }
                    }
                    .selected.box{
                        border: 0.01rem solid #409EFF;
                    }
                    .box + .box {
                        margin-left: 0.36rem;
                    }
                }
                .btns {
                    height: 0.76rem;
                    line-height: 0.76rem;
                    text-align: center;
                    .tip{
                        color:  #F56C6C;
                        font-size: 0.28rem;
                    }
                }
            }
        }
    }
</style>